import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';

export interface IGeneralStylesheetContainerProps extends IBaseElementProps {
	/**
	 * General Stylesheet Container Title
	 */
	title?: string;
	children?: any;
}

// TODO: Component currently exposed for Design Review - Remove Block decorator prior to content entry.

/**
 * GeneralStylesheetContainer
 * @block
 * @requiresHooks
 * @icon text
 */
const GeneralStylesheetContainer: React.FC<IGeneralStylesheetContainerProps> =
	({ title, children, className, classNames = [] }) => (
		<section
			className={
				className || cn('general-stylesheet-container', ...classNames)
			}
		>
			<div className="general-stylesheet-container__fluid container-fluid p-0">
				<div className="row">
					<div className="col-12">
						{title && (
							<h2 className="general-stylesheet-container__title">
								{title}
							</h2>
						)}
					</div>
				</div>
				{children}
			</div>
		</section>
	);

export default GeneralStylesheetContainer;
